import React from 'react';
import { StyleSheet } from 'react-native';
import { ThemeIcon } from '@24i/nxg-sdk-quarks';
import styled, { css } from 'styled-components';
export const PlayerIcon = ({ className = '', backgroundColor = 'transparent', name, style = {}, }) => {
    const flastStyles = StyleSheet.flatten(style);
    const getIconSize = () => flastStyles != null && typeof flastStyles.width === 'number' ? flastStyles.width : 24;
    return (React.createElement("div", { style: Object.assign({ backgroundColor }, style), className: className },
        React.createElement(ThemeIcon, { size: getIconSize(), iconName: name })));
};
const baseIconStyles = css `
    position: relative;
    width: 24px;
    height: 24px;
`;
export const StyledIcon = styled(PlayerIcon) `
    ${baseIconStyles}
`;
//# sourceMappingURL=index.js.map